export const TENANT_ID_SET = "TENANT_ID_SET";
export const TENANT_ID_INTERCEPTOR_SET = "TENANT_ID_INTERCEPTOR_SET";

export interface ITenantIdPayload {
  tenantId?: string;
  interceptorId?: number;
}

export const createTenantIdSetAction = (payload: ITenantIdPayload) => {
  return {
    type: TENANT_ID_SET,
    payload,
  };
};

export const createTenantIdInterceptorSetAction = (
  payload: ITenantIdPayload
) => {
  return {
    type: TENANT_ID_INTERCEPTOR_SET,
    payload,
  };
};
